import { render, staticRenderFns } from "./OrderModeSwitchDialog.vue?vue&type=template&id=36b70a8c&scoped=true"
import script from "./OrderModeSwitchDialog.vue?vue&type=script&lang=js"
export * from "./OrderModeSwitchDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderModeSwitchDialog.vue?vue&type=style&index=0&id=36b70a8c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b70a8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Projekte\\Tipsiolive\\tipsiapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36b70a8c')) {
      api.createRecord('36b70a8c', component.options)
    } else {
      api.reload('36b70a8c', component.options)
    }
    module.hot.accept("./OrderModeSwitchDialog.vue?vue&type=template&id=36b70a8c&scoped=true", function () {
      api.rerender('36b70a8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/orderModeSwitch/OrderModeSwitchDialog.vue"
export default component.exports